var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{ref:"echarts",attrs:{"autoresize":"","options":_vm.compareOptions,"theme":"ptom-echart-theme"}})
}
var staticRenderFns = []

export { render, staticRenderFns }